import {
  HOME_CLIENT_ORGANIZATION_BEGIN,
  HOME_CLIENT_ORGANIZATION_SUCCESS,
  HOME_CLIENT_ORGANIZATION_FAILURE,
  HOME_CLIENT_ORGANIZATION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';

export function clientOrganization(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_CLIENT_ORGANIZATION_BEGIN,
    });

    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}clients/organization/client`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CLIENT_ORGANIZATION_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_CLIENT_ORGANIZATION_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>clientOrganization', err);
        },
      );
    });

    return promise;
  };
}

export function dismissClientOrganizationError() {
  return {
    type: HOME_CLIENT_ORGANIZATION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CLIENT_ORGANIZATION_BEGIN:
      return {
        ...state,
        clientOrganizationPending: true,
        clientOrganizationError: null,
      };

    case HOME_CLIENT_ORGANIZATION_SUCCESS:
      return {
        ...state,
        clientOrganizationPending: false,
        clientOrganizationError: null,
        orgClient: action.data,
      };

    case HOME_CLIENT_ORGANIZATION_FAILURE:
      return {
        ...state,
        clientOrganizationPending: false,
        clientOrganizationError: action.data.error,
      };

    case HOME_CLIENT_ORGANIZATION_DISMISS_ERROR:
      return {
        ...state,
        clientOrganizationError: null,
      };

    default:
      return state;
  }
}
